export const REQUIRED_FIELD = 'Campo obrigatório!'
export const ONLY_NUMBER = 'Digite apenas números!'
export const INVALID_FIELD = 'Campo inválido!'
export const VERY_LARGE_FILE = 'O tamanho total dos arquivos deve ser menor que 10MB!'
export const SAME_VALUE = 'Os campos devem ser diferentes!'
export const BIGGER_ZERO = 'O valor deve ser maior que zero!'